import './PartnerSection.css';

export default function PartnerSection() {
  return (
    <section className="partner">
      <div className="partner__container">
        <div className="partner__left">
          <p className="partner__eyebrow">Partner program</p>
          <h2 className="partner__heading">An open partner program, with the economics written down</h2>
          <p className="partner__body">Most partner programs in this category are quiet, gated and opaque. settlor.money's is the opposite. Published partner tiers, real revenue share, co-marketing, integration support and a partner success contact who answers the phone. Whether you're a fintech, an ISV, a marketplace or a banking correspondent, the door is open and the terms are clear.</p>
          <a href="#partner" className="partner__cta">
            Become a partner
            <svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 15 15" fill="none">
              <path d="M3.125 7.5H11.875" stroke="white" strokeWidth="1.5625" strokeLinecap="round" strokeLinejoin="round"/>
              <path d="M7.5 3.125L11.875 7.5L7.5 11.875" stroke="white" strokeWidth="1.5625" strokeLinecap="round" strokeLinejoin="round"/>
            </svg>
          </a>
        </div>
        <div className="partner__right">
          <blockquote className="partner__quote">
            <p>"settlor.money was the first program that put partner economics on the home page. The revenue share is clear, the onboarding is fast, and the team actually returns calls."</p>
            <footer>
              <strong>Founder</strong>
              <span>Embedded-payments startup</span>
            </footer>
          </blockquote>
        </div>
      </div>
    </section>
  );
}
